import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../api/index';

Vue.use(Vuex);

const state = {
    quser: {},
    system: {
        env: 'develop',
        openApi: '',
        headUrl: '',
        footUrl: '',
        areaType: '',
    },
    registerNo: '',
    isMac: /macintosh|mac os x/i.test(navigator.userAgent),
};
const getters = {
    quser: state => {
        return state.quser;
    },
    system: state => {
        return state.system;
    },
    isMac: state => {
        return state.isMac;
    },
    isPersonal: state => state.quser.user && ['PERSONAL'].includes(state.quser.user.tenantType),
    isLP: state => state.quser.user && ['LP'].includes(state.quser.user.tenantType),
    isEtl: state => state.quser?.user?.registerSource === 'etl',
    /** 企业云登录 */
    isEcloud: state => state.quser && state.quser.user && state.quser.user.registerSource === 'ecloud',
};

const mutations = {
    saveQuser (state, data) {
        if (!data) return;
        state.quser = data.data.result;
    },
    saveSystemConfig (state, data) {
        if (!data) return;
        state.system.env = data.data.env;
        state.system.openApi = data.data.result;

        // iframe 嵌入的头 （支持后台配置）
        state.system.headUrl = data.data.headUrl;
        // iframe 嵌入的尾 （支持后台配置）
        state.system.footUrl = data.data.footUrl;

        // 当前地区类型
        state.system.areaType = data.data.areaType;

        state.system.alertMessage = data.data.alertMessage;

        localStorage.setItem('SYSTEM_ENV', data.data.env);
        document.title = data.data.appName;
    },
    saveRegisterNo(state, data) {
        state.registerNo = data.data.result;
    },
};
const actions = {
    async initQuser({ commit }, params) {
        commit(
            'saveQuser',
            await axios({
                url: '/user',
                method: 'GET',
                params: params
            })
        );
    },
    initSystemConfig({ commit }) {
        return new Promise(async (resolve, reject) => {
            const result = await axios({
                url: '/shusp/env',
                method: 'GET'
            })
            commit(
                'saveSystemConfig',
                result
            );
            resolve();
        });
    },
    async getRegisterNo({ commit }, cert) {
        let data = new FormData();
        data.append('cert', cert);
        commit(
            'saveRegisterNo',
            await axios({
                url: '/cert/creditcode',
                method: 'POST',
                data
            })
        );
    }
};

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
});
